module.exports = __webpack_public_path__ + "static/img/rongyu3.f1259e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyu3.jpg
// module id = Itzn
// module chunks = 1